import { addUserActionNotificationError } from "~/actions/user_notification";
import type { TUserActionNotification } from "~/reducers/dashboard";
import { useAppDispatch } from "~/store";

/**
 * Helper hook to dispatch user action notifications.
 */
export function useUserActionNotification() {
  const dispatch = useAppDispatch();

  function error(message: TUserActionNotification["message"]) {
    return dispatch(addUserActionNotificationError({ message }));
  }

  return { error };
}
